module.exports = __webpack_public_path__ + "img/windsock.min.acf110d1d7e071ef0532b2f43a1a1885.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/windsock.min.svg
// module id = 175
// module chunks = 0